"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
class CustomerNotification {
    constructor(options, attributes = {}) {
        this.options = options;
        this.attributes = attributes;
        this.throwErrorIfNotificationOptionsConfiguredImproperly();
    }
    getMessageType() {
        return this.options.messageType;
    }
    getOptions() {
        return this.options;
    }
    getAttributes() {
        return this.attributes;
    }
    toJSON() {
        return {
            attributes: this.getAttributes(),
            options: this.getOptions()
        };
    }
    isBanner() {
        return (0, lodash_1.isObject)(this.options.banner);
    }
    isModal() {
        // Code for modal is not written
        return (0, lodash_1.isObject)(this.options.modal);
    }
    isVisible(location) {
        // Note: Proper way is pass $vue.router here and check there, without such monkey .includes checks, but not in this ticket
        if ((0, lodash_1.isUndefined)(window)) {
            throw new Error('This method is usable only in browser');
        }
        const { showIfUrlContains, hideIfUrlContains } = this.options.visibility;
        const showPatternMatches = (showIfUrlContains ?? []).filter((p) => location.href.includes(p));
        const hidePatternMatches = (hideIfUrlContains ?? []).filter((p) => location.href.includes(p));
        if (hidePatternMatches.length > 0) {
            return false;
        }
        if (Array.isArray(showIfUrlContains) && showIfUrlContains.length > 0 && showIfUrlContains[0] !== '*') {
            return showPatternMatches.length > 0;
        }
        return true;
    }
    throwErrorIfBannerNotificationConfiguredImproperly() {
        if ((0, lodash_1.isNil)(this.options.banner)) {
            throw new Error('Banner notification options not configured');
        }
        const { update, key } = this.options.banner;
        if (update && !(0, lodash_1.isString)(key)) {
            throw new Error('CustomerNotification (Banner): parameter "update": true is incompatible with missing "key" parameter');
        }
    }
    throwErrorIfNotificationOptionsConfiguredImproperly() {
        if ([this.options.banner, this.options.modal].filter(lodash_1.isNil).length !== 1) {
            throw new Error('CustomerNotification configured improperly (only single option allowed: banner or modal)');
        }
    }
}
exports.default = CustomerNotification;
